import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getProductState } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import {
    chain,
    LoadRealTimePrices,
} from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/LoadProductPricingAndInventory";

replaceInChain(chain, LoadRealTimePrices, async props => {
    if (!props.parameter.product || !props.parameter.productInfosById) {
        return;
    }

    const productIds = Object.keys(props.parameter.productInfosById);
    let productPriceParameters = productIds.map(productId => {
        const productInfo = props.parameter.productInfosById![productId];
        return {
            productId: productInfo!.productId,
            unitOfMeasure: productInfo!.unitOfMeasure,
            qtyOrdered: productInfo!.qtyOrdered,
        };
    });

    // Verndale Customization
    const state = props.getState();
    const product = getProductState(state, props.parameter.product?.id).value;

    if (product) {
        const properties = product.properties;
        if (properties) {
            const isCmiProduct = properties.isCmiProduct;
            const customerLength = properties.customerLength;
            const standardPutup = properties.standardPutup;

            productPriceParameters = productIds.map(productId => {
                const productInfo = props.parameter.productInfosById![productId];
                let qtyOrdered = productInfo!.qtyOrdered;

                if (String(isCmiProduct).toLowerCase() === "true") {
                    if (typeof customerLength === "string" && customerLength !== "") {
                        qtyOrdered = Number(customerLength.replace(/,/g, ""));
                    } else if (typeof standardPutup === "string" && standardPutup !== "") {
                        qtyOrdered = Number(standardPutup.replace(/,/g, ""));
                    }
                }
                return {
                    productId: productInfo!.productId,
                    unitOfMeasure: productInfo!.unitOfMeasure,
                    qtyOrdered,
                };
            });
        }
    }
    // END Verndale Customization

    // Always load realtime pricing. Quote-required is decided from realtime inventory
    // (additionalResults.isQuoteRequired) via useCustomQuoteRequired — not catalog quoteRequired.
    // Skipping pricing here left ProductPrice stuck in loading when inventory said buyable.
    props.dispatch(
        loadRealTimePricing({
            productPriceParameters,
            onComplete: pricingProps => {
                if (pricingProps.apiResult?.realTimePricingResults) {
                    const pricing = pricingProps.apiResult.realTimePricingResults!.find(
                        o => o.productId === props.parameter.product?.id,
                    );
                    if (pricing) {
                        props.dispatch({
                            type: "Pages/ProductDetails/CompleteLoadRealTimePricings",
                            pricings: pricingProps.apiResult.realTimePricingResults,
                        });
                    } else {
                        props.dispatch({
                            type: "Pages/ProductDetails/FailedLoadRealTimePricings",
                            productIds,
                        });
                    }
                } else if (pricingProps.error) {
                    props.dispatch({
                        type: "Pages/ProductDetails/FailedLoadRealTimePricings",
                        productIds,
                    });
                }

                props.pricingLoaded = true;
            },
        }),
    );

    if (getSettingsCollection(props.getState()).productSettings.inventoryIncludedWithPricing) {
        await waitFor(() => !!props.pricingLoaded);
    }
});
